<div class="chart">
  <div class="svg-wrapper">
    <svg name="doughnut" class="doughnut"></svg>
  </div>
</div>
<div name="labels" class="labels">
  @for (datum of data; track i; let i = $index) {
    <app-percent-bar
      [class]="'bar-' + i"
      [data]="datum"
      [label]="labelAccessor()(datum)"
      [total]="total"
      [valueAccessor]="valueAccessor()"
      [disableTransitions]="disableTransitions()"
    />
  }
</div>
